import { Box, Card, Collapse, IconButton, Paper, Stack, Tooltip, Typography } from "@mui/material";
import Loading from "../../components/Loading";
import { makeLabelRow } from "./Extras";
import RestoreIcon from '@mui/icons-material/Restore';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { PurchaseOrderContentField } from "./ContentField";
import { POPreviewView } from "./POPreviewView";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const FormColors = {
    MainBg:   "#f0f0f7",
    GroupBg:   "#f7f7f7",
    PriceBg:  "#e0e0f7",
    RowBg:    "#fefefe",
    RowBgAlt: "#fafafa"
};

const LinkButton = ({url}) => {

}

const PurchaseOrderTableRow = ({fields, total_rows, conditions, definitions, data, index,
    minElementWidth, inlinePreview, readOnly, handleTableChange, applyToAll,
    validationErrors, buttons}) => {
    function selectToInclude(r) {
        var ret = [];
        fields.forEach((f) => {
          if(f.type === "variable") return;
          if(f.backend) return;
          if(f.conditional) {
            let condition = f.conditional;
            if(!r) return;
            if(r._conditions && r._conditions[condition]) {
              ret.push(f);
            } else {
              ret.push({...f, hidden: true});
            }
          } else {
            ret.push(f);
          }
        });
        return ret;
    }

    function defaultValue(data, field) {
        if(!data) return undefined;
        let defaults = data["_defaults"];
        if(defaults) {
          let match = defaults[field.key];
          if (match) {
            return `${match}`;
          }
        }
        return undefined;
    }
  
    const included_fields = selectToInclude(data);
    let groups = ["Main"];
    included_fields.forEach(field => {
      if(field.group !== "") {
        if(!groups.includes(field.group)) {
          groups.push(field.group);
        }
      }
    });
    let rowbg = index % 2 === 0 ? FormColors.RowBg : FormColors.RowBgAlt;
    let row_title = data ? ((data._automatic || `Line Item ${index+1}`) + (data._automatic ? " (Automatic)" : "")) : `Line Item ${index+1}`;
    return <Card key={`card_table_row_${index}`} variant="outlined" sx={{marginBottom: 2, backgroundColor: rowbg, minHeight: 100}}>
      <Box key={`table_row_${index}`} open={false} sx={{ padding: 1 }}>
        <Stack direction="row" sx={{ padding: 0}}>
        <Stack direction="column" sx={{ padding: 0}}>
        <Stack direction="row" sx={{height: 32}} alignItems={"center"} spacing={4}>
        <Typography variant="h2">{row_title}</Typography>
        </Stack>
        {
            groups.map((group, group_idx) => {
                const these_included_fields = included_fields.filter((f) => (group === f.group))
                let group_hidden = true;
                these_included_fields.forEach((field) => {
                    if(!field.hidden) group_hidden = false;
                });
                let groupbg = group === "Main" ? FormColors.MainBg : FormColors.GroupBg;
                
                return <Collapse key={`collapse_${index}_${group}`} mountOnEnter unmountOnExit in={!(group_hidden | false)}><Box key={`box_${index}_${group}`} hidden={group_hidden}>
                {group !== "Main" ? <Typography variant="h3">{group}</Typography> : <></>}
                <Box display="flex" flexWrap={"wrap"} key={`row_${index}`} sx={{marginBottom: 2, marginTop: 1}}>
                {these_included_fields.map((field, field_index) => {
                    let defval = defaultValue(data, field);
                    let hasDefault = defval !== undefined;
                    let elementWidth = (field.key === "room_number") ? minElementWidth * 2 / 3 : minElementWidth;
                    let itembg = (field.key === "price" || field.key === "total") ? FormColors.PriceBg : groupbg;
                    let isNotDefault = data ? (((data[field.key] || null) !== defval) && data[field.key]) : false;
                    let makeDefaultButton = null;
                    let applyToAllButton = null;
                    let fieldLinkButton = null;
                    if (field.hasurl ?? false) {
                      let linkUrl = data._links?.[field.key] ?? null;
                      if (linkUrl) {
                        fieldLinkButton = (
                          <Tooltip title="Open preview in new tab">
                          <IconButton color="primary" sx={{padding: "2px"}}
                            onClick={() => {
                              window.open(linkUrl, "_blank");
                            }}
                          ><OpenInNewIcon sx={{padding: 0, margin: 0, width: 16}} /></IconButton>
                          </Tooltip>
                        );
                      }
                    }
                    if (hasDefault && isNotDefault)
                        makeDefaultButton = <Tooltip title={`Reset to ${defval}`}>
                            <IconButton color="primary" sx={{padding: "2px"}}
                            onClick={() => {
                            handleTableChange({
                                rowKey: index,
                                fieldKey: field.key,
                                value: null
                            });
                            }}
                            ><RestoreIcon sx={{padding: 0, margin: 0, width: 16}} /></IconButton>
                        </Tooltip> 
                    if (total_rows > 1)
                      if(field.type !== "auto" && field.type !== "total")
                        applyToAllButton = <Tooltip title="Apply to all">
                            <IconButton color="primary" sx={{padding: "2px"}}
                            onClick={() => {
                                applyToAll(field, index);
                            }}
                            ><KeyboardDoubleArrowDownIcon sx={{padding: 0, margin: 0, width: 16}} /></IconButton>
                        </Tooltip>;
                      else
                       applyToAllButton = <Box sx={{height: 24}} />;
                    return <Collapse key={`${index}_${field_index}_${field.label}`} mountOnEnter unmountOnExit in={!(field.hidden | false)}>
                        <Paper key={`${index}_${field_index}_${field.label}_paper`} variant="outlined" sx={{paddingBottom: 0, margin: "2px", backgroundColor: itembg}}>
                        <Box key={`box_${index}_${field_index}_${field.label}`}
                            sx={{
                                margin: 0,
                                padding: "2px",
                                width: elementWidth,
                                minHeight: "60px"
                            }}>
                        <Stack direction="column" sx={{minHeight: "60px"}}>
                            <Stack direction="row" justifyContent={"space-between"} sx={{height: "24px"}}>
                                {makeLabelRow(field, 0)}
                                {fieldLinkButton}
                                {makeDefaultButton}
                                {applyToAllButton}
                            </Stack>
                            <PurchaseOrderContentField
                                field={field}
                                hasErrors={validationErrors?.[field.key] || false}
                                readOnly={readOnly}
                                onChange={(value) => {
                                handleTableChange({
                                    rowKey: index,
                                    fieldKey: field.key,
                                    value: value
                                });
                                }}
                                options={field.type === "choice" ? definitions[field.options] : []}
                                current_value={data?.[field.key] || ""}
                                default_value={defaultValue(data, field)}
                                controlVariant="outlined"
                                controlSize="small"
                                elementWidth={elementWidth}
                            />
                        {makeLabelRow(field, 1)}
                    </Stack>
                </Box></Paper></Collapse>
        })}
        </Box>
      </Box>
      </Collapse>
  })}
  {readOnly ? <></> : <Stack direction="row" sx={{padding: 0, gap: 1, alignItems: "center", paddingTop: "4px", paddingLeft: "4px", paddingRight: "4px"}}>{buttons}</Stack>}
  </Stack>
  {inlinePreview === index ? <Box
    sx={{minWidth: 550}}
  ><POPreviewView data={data} /></Box> : <></>}
  </Stack>
  </Box></Card>
};

export { PurchaseOrderTableRow };